import { render } from "./VerseReference.vue?vue&type=template&id=718a94a8&scoped=true"
const script = {}

import "./VerseReference.vue?vue&type=style&index=0&id=718a94a8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718a94a8"]])

export default __exports__